// extracted by extract-css-chunks-webpack-plugin
module.exports = {"notifyMeButton":"notifyMeButton_RtfiX"};